/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';
    var app = angular.module('enervee');

    app.directive('moreInfoModal', [function() {
        return {
            restrict: 'E',
            controller: [
                '$scope',
                'UtilService',
                function (
                    $scope,
                    UtilService
                ) {
                    $scope.moreInfoTitle = UtilService.getSiteSetting('info_modal_title');
                    $scope.moreInfoBody = UtilService.getSiteSetting('info_modal_body');
                    $scope.moreInfoButton = UtilService.getSiteSetting('info_modal_button');
                }],
            template: require('@app/shared/modals/moreInfo/moreInfo.html'),
        };

    }]);

})(angular);